import { render, staticRenderFns } from "./CadastroDocumentacao.vue?vue&type=template&id=5d5620f4&scoped=true&lang=pug&"
import script from "./CadastroDocumentacao.vue?vue&type=script&lang=js&"
export * from "./CadastroDocumentacao.vue?vue&type=script&lang=js&"
import style0 from "./CadastroDocumentacao.vue?vue&type=style&index=0&id=5d5620f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5620f4",
  null
  
)

export default component.exports